"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Maybe describes a value that is optional. It is safer to use then null and
 * undefined.
 */

var Maybe =
/** @class */
function () {
  function Maybe() {}

  return Maybe;
}();

exports.default = Maybe;